import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";

import { useStoreFeaturesContext } from "../../context/storeFeatures.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { storeFeatures } = useStoreFeaturesContext();
    return <Mapped array={storeFeatures}>{children}</Mapped>;
};

export { Base };
